<template>
  <div id="application_pay_outer">
    <div class="pay-title"><span class="iconfont" style="margin-right: 10px;">&#xe609;</span> 微信支付</div>
    <wechat-pay-card style="margin-top: 15px;"
                     v-bind:pay-model="payInforData"
                     v-on:payClicked="payButtonClicked" ></wechat-pay-card>

    <div style="margin-top: 15px;color: #fc1a34;font-weight: bold;">支付金额：{{amount + '元'}}</div>
    <div v-if="showQrCode" style="margin-top: 10px;color: #666;">扫码付款</div>

  </div>
</template>

<script>
  import '../../../js/jquery.qrcode.min';
  import WechatPayCard from "../../common/WechatPayCard";
  import WeixinManager from "../../../js/weixin.config";
export default {
  name: "ApplicationPaying",
  components: {
    WechatPayCard
  },
  data() {
    return {
      amount: 500,
      payInforData: null,
      tradeType: null,
      checkInterval: null,
      showQrCode: true,
      neededAutoCheckPayStatus: false,
      code: null,
      wechatData: null,
    }
  },
  mounted() {
    this.initPayParams();
    this.initAutoCode();
    this.loadQrCodeData();
  },
  destroyed() {
    this.closeInterval();
  },
  computed: {
    httpManager() {
      return this.$store.state.http;
    },
    user() {
      return this.$store.state.user;
    },
    dataManager() {
      return this.$store.state.dataStore;
    },
  },
  methods: {

    initPayParams() {
      if (this.isPc()) { // pc端
        this.tradeType = 'NATIVE';
        this.showQrCode = true;
        this.neededAutoCheckPayStatus = true;
      } else { // 移动端
        this.showQrCode = false;
        if (this.isWeixin()) {
          this.tradeType = 'JSAPI';
          this.neededAutoCheckPayStatus = false;
        } else {
          this.tradeType = 'MWEB';
          this.neededAutoCheckPayStatus = true;
        }
      }
    },


    initAutoCode() {
      if (this.tradeType == 'JSAPI') {
        let query = this.$route.query;
        let state = query.state;
        if (state == this.weichatAutoState.pay) {
          let code = query.code;
          if (code != undefined) {
            this.code = code;
            this.$router.push({
              name: this.$route.name,
              params: this.$route.params,
              query: {}
            });
          }
        } else {
          let redirect_url = window.location.href;
          WeixinManager.jsapi_payAutorize(redirect_url);
        }
      } else if (this.tradeType == 'MWEB') {
        //outTradeNo
        let query = this.$route.query;
        let outTradeNo = query.outTradeNo;
        if (outTradeNo != undefined && outTradeNo != null && outTradeNo.length > 0) {
          //...更新状态
          this.checkPayStatusAtBegin(outTradeNo);
        }
      }
    },

    weichatPaySuccess() {
      this.$toast('支付成功！');
      this.$emit('paySuccess');
    },

    payButtonClicked() {
      let params = this.payInforData;
      if (params == null) {
        return;
      }

      if (this.tradeType == 'JSAPI') {
        let _this = this;
        WeixinManager.jsapi_sendPayRequest(params, function (data) {
          _this.$toast('支付成功！');
          _this.checkPayStatus();
        }, function (data) {
          // loadFlags.close();
          // _this.$toast(data.err_msg);

        });
      } else { // h5 支付
        let mwebUrl = params.mwebUrl;
        if (mwebUrl != null && mwebUrl.length > 0) {
          let url =  window.location.href;
          if (this.isSafari()) {
            url += "?outTradeNo=" + params.outTradeNo;
            url = encodeURI(url);
          }
          mwebUrl += '&redirect_url=';
          mwebUrl += url;
          window.open(mwebUrl, '_self');
        }
      }
    },

    loadQrCodeData() {
      let params = {
        productId: 0,
        tradeType: this.tradeType
      };

      if (!this.code != null) {
        params.code = this.code;
      }

      let _this = this;
      this.httpManager.ajax.getPayUnifiedorderData(params, function (data) {
        let code = data.code;
        if (code == 0) {
          _this.payInforData = data.data;
          _this.code = null;
          if (_this.neededAutoCheckPayStatus) {
            _this.startInterval();
          }
          return;
        }
      }, function (data) {
      });
    },


    checkPayStatusAtBegin(outTradeNo) {
      let params = {
        outTradeNo
      };
      let _this = this;
      this.httpManager.ajax.getPayWxPayCheckData(params, function (data) {
        let code = data.data;
        if (code == 1) {
          _this.checkInterval = null;
          _this.$router.push({
            name: _this.$route.name,
            params: _this.$route.params,
            query: {}
          });
          _this.weichatPaySuccess();
          //...
        } else {
          _this.startInterval();
        }
      }, function (data) {
        _this.startInterval();
      });
    },

    checkPayStatus() {
      let outTradeNo = this.payInforData.outTradeNo;
      let params = {
        outTradeNo
      };
      let _this = this;
      this.httpManager.ajax.getPayWxPayCheckData(params, function (data) {
        let code = data.data;
        if (code == 1) {
          _this.checkInterval = null;
          _this.weichatPaySuccess();
          //...
        } else {
          _this.startInterval();
        }
      }, function (data) {
        _this.startInterval();
      });
    },

    startInterval() {
      if (!this.neededAutoCheckPayStatus || this.payInforData == null) {
        return;
      }
      this.checkInterval = setTimeout(this.checkPayStatus, 10 * 1000);
    },
    closeInterval() {
      if (this.checkInterval != null) {
        clearTimeout(this.checkInterval);
        this.checkInterval = null;
      }
    },

  }
}
</script>

<style scoped>
  #application_pay_outer {
    padding: 15px 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
  }

  #application_pay_outer .pay-title {
    font-size: 1.5rem;
    font-weight: bold;
    color: #333;
    margin-top: 30px;
  }

  #appli_pay_card {
    width: 200px;
    height: 200px;
    margin-top: 20px;
  }


</style>



// WEBPACK FOOTER //
// src/components/personal/personApplicationVues/ApplicationPaying.vue